// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"68397ce8","739":"37957342","861":"06b008a9"}[chunkId] + ".chunk.js";
};